import React, { useState } from 'react';
import MenuAdmin from './MenuAdmin';
import ModifierGroups from './ModifierGroups';
import Stations from './Stations';
import TablesAdmin from './TablesAdmin';
import TabBar from '../components/TabBar';

const TABS = [
  { id: 'menu',      label: '📋 Menu'         },
  { id: 'modifiers', label: '🧩 Mod. grupy'   },
  { id: 'stations',  label: '🍳 Stanowiska'   },
  { id: 'tables',    label: '🪑 Stoliki'       },
];

export default function MenuSettings() {
  const [tab, setTab] = useState('menu');

  return (
    <div style={{ padding: '20px 24px' }}>
      <h2 style={{ fontSize: 18, fontWeight: 500, marginBottom: 16 }}>Menu</h2>

      <TabBar tabs={TABS} active={tab} onChange={setTab} />

      {tab === 'menu'      && <MenuAdmin embedded />}
      {tab === 'modifiers' && <ModifierGroups embedded />}
      {tab === 'stations'  && <Stations embedded />}
      {tab === 'tables'    && <TablesAdmin embedded />}
    </div>
  );
}
